import { render, staticRenderFns } from "./luckdraw.vue?vue&type=template&id=1114063c&scoped=true&"
import script from "./luckdraw.vue?vue&type=script&lang=js&"
export * from "./luckdraw.vue?vue&type=script&lang=js&"
import style0 from "./luckdraw.vue?vue&type=style&index=0&id=1114063c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1114063c",
  null
  
)

export default component.exports